<script>
import UploadImage from '@/components/ux/upload/Upload-image.vue';

export default {
  components: { UploadImage },
  data() {
    return {
      fileList: [],
    };
  },
  props: {
    files: {
      type: Array,
    },
    isMultiple: {
      type: Boolean,
      required: true,
    },
    isShowUploadList: {
      type: Boolean,
      default: true,
    },
    onChange: Function,
  },
  mounted() {
    this.fileList = this.files;
  },
  watch: {
    fileList: {
      handler(newValue) {
        this.onChange(newValue);
      },
      deep: true,
    },
    files(newVal) {
      this.fileList = newVal;
    },
  },
};
</script>

<template>
  <upload-image
    v-model:files="fileList"
    :is-multiple="isMultiple"
    :initial-images="files"
    :is-show-upload-list="isShowUploadList"
  />
</template>

<style scoped>
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}
</style>
